"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.classes = exports.LunaTypeSets = exports.LunaTypeTypes = void 0;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var __baseClass = 'luna-type';

function getClasses(sizes, variant) {
  var classes = {};

  for (var size in sizes) {
    classes[size] = "".concat(__baseClass, "-").concat(variant, "-").concat(sizes[size]);
  }

  return classes;
}

var LunaTypeTypes = {
  header: 'headers',
  body: 'bodys',
  data: 'datas',
  support: 'supports'
};
exports.LunaTypeTypes = LunaTypeTypes;
var LunaTypeHeaderSizes = {
  l10: '10',
  l15: '15',
  l20: '20',
  l25: '25',
  l30: '30',
  l35: '35',
  l40: '40',
  l45: '45',
  l50: '50',
  l55: '55',
  l60: '60',
  l65: '65'
};
var LunaTypeBodySizes = {
  l10: '10',
  l15: '15',
  l20: '20',
  l25: '25',
  l30: '30',
  l35: '35'
};
var LunaTypeDataSizes = {
  l10: '10',
  l15: '15',
  l20: '20',
  l25: '25',
  l30: '30',
  l35: '35',
  l40: '40',
  l45: '45'
};
var LunaTypeSupportSizes = {
  l10: '10',
  l20: '20'
};
var LunaTypeSets = {
  header: getClasses(LunaTypeHeaderSizes, 'header'),
  body: getClasses(LunaTypeBodySizes, 'body'),
  data: getClasses(LunaTypeDataSizes, 'data'),
  support: getClasses(LunaTypeSupportSizes, 'support')
};
exports.LunaTypeSets = LunaTypeSets;
var LunaTypeHierarchy = {
  secondary: 'secondary'
};
var classes = {
  typeSets: LunaTypeSets,
  colors: _defineProperty({}, LunaTypeHierarchy.secondary, "".concat(__baseClass, "-secondary")),
  resetMarginClass: "".concat(__baseClass, "-spacing_reset")
};
exports.classes = classes;
